import axios from './Api';

export function GetJobStatus(cityHallId?: string | number) {
  return axios.get<Job.IJobExport[]>(`/adminpartners/additions/export/status`, { params: { cityHallId } });
}

export function CancelJob(additionsExportId: string | number) {
  return axios.get<Axios.IResponseSuccess>(`/adminpartners/additions/export/${additionsExportId}/cancel`);
}

export function GerJobFile(additionsExportId: string | number,) {
  return axios.get<Job.IJobExportFile>(`/adminpartners/additions/export/${additionsExportId}/download`, {
    params: { additionsExportId, },
    responseType: 'blob'
  });
}

export function StartJob(cityHallId?: string | number, season?: 0 | 1) {
  return axios.post<Job.IJobExport>('/adminpartners/additions/export', null, { params: { cityHallId, season } });
}
